/* Brossange : brosse en relief (D32). Relief qui suit le pointeur ou le doigt, nuancier des finitions qui repeint
   la brosse, synchronisation avec la couleur de la fiche, loupe et gros plan, apparitions au défilement.
   Mouvement réduit respecté : rien ne bouge seul, la brosse reste à l'état final. */
(() => {
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  const FINITIONS = ['noir', 'dore', 'rose-dore', 'argente'];
  // C12 : file commune lue par brossange-track.js (publication seulement avec l'accord « Analyse »)
  const publier = (nom, data) => {
    try { (window.brossangeQ = window.brossangeQ || []).push([nom, data]); } catch (e) { /* suivi facultatif */ }
  };
  const poignee = (texte) => String(texte || '').toLowerCase()
    .replace(/[àâä]/g, 'a').replace(/[éèêë]/g, 'e').replace(/[îï]/g, 'i').replace(/[ôö]/g, 'o').replace(/[ùûü]/g, 'u')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  /* 1. Relief : la souris incline la brosse, le doigt la fait pivoter par un glisser horizontal, retour amorti */
  const relief = (zone) => {
    const brosse = zone.querySelector('[data-brosse]');
    const objet = zone.querySelector('[data-brosse-objet]');
    if (!brosse || !objet) return;
    let cx = 0; let cy = 0; let tx = 0; let ty = 0; let raf = 0;
    const boucle = () => {
      cx += (tx - cx) * 0.12;
      cy += (ty - cy) * 0.12;
      objet.style.setProperty('--tx', `${(cx * 18).toFixed(2)}deg`);
      objet.style.setProperty('--ty', `${(-cy * 11).toFixed(2)}deg`);
      brosse.style.setProperty('--rx', cx.toFixed(3));
      raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.002 ? requestAnimationFrame(boucle) : 0;
    };
    const viser = (x, y) => {
      tx = Math.max(-1, Math.min(1, x));
      ty = Math.max(-1, Math.min(1, y));
      if (!raf) raf = requestAnimationFrame(boucle);
    };
    zone.addEventListener('pointermove', (e) => {
      // Fiche : la loupe prend la souris, le relief reste au doigt
      if (calme.matches || e.pointerType !== 'mouse' || zone.hasAttribute('data-loupe')) return;
      const r = zone.getBoundingClientRect();
      viser(((e.clientX - r.left) / r.width) * 2 - 1, ((e.clientY - r.top) / r.height) * 2 - 1);
    });
    zone.addEventListener('pointerleave', () => viser(0, 0));
    // Au doigt : écouteurs sur la fenêtre, pas de capture ; la page garde le défilement vertical (touch-action: pan-y)
    let depart = null;
    brosse.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' || calme.matches) return;
      depart = e.clientX;
    });
    window.addEventListener('pointermove', (e) => {
      if (depart === null) return;
      viser((e.clientX - depart) / 110, 0);
    }, { passive: true });
    const lacher = () => {
      if (depart === null) return;
      depart = null;
      viser(0, 0);
    };
    window.addEventListener('pointerup', lacher);
    window.addEventListener('pointercancel', lacher);
  };
  $$('[data-relief]').forEach(relief);

  /* 2. Finition : repeint la brosse avec un reflet qui balaie la coque */
  const plaquer = (brosse, finition) => {
    if (!brosse || !FINITIONS.includes(finition) || brosse.dataset.finition === finition) return;
    brosse.dataset.finition = finition;
    if (calme.matches) return;
    brosse.classList.remove('is-plating');
    void brosse.offsetWidth;
    brosse.classList.add('is-plating');
  };
  document.addEventListener('animationend', (e) => {
    if (e.animationName !== 'bz-plaque') return;
    const brosse = e.target.closest('[data-brosse]');
    if (brosse) brosse.classList.remove('is-plating');
  });

  /* 3. Nuancier du hero : nom de la finition, lien de la fiche réglé sur la variante, événement de suivi */
  $$('[data-finitions]').forEach((groupe) => {
    const section = groupe.closest('section');
    const nom = groupe.querySelector('[data-finition-nom]');
    const appliquer = (input, suivi) => {
      plaquer(section && section.querySelector('[data-brosse]'), input.value);
      if (nom) nom.textContent = input.dataset.nom || input.value;
      const cta = section && section.querySelector('[data-cta-fiche]');
      if (cta && input.dataset.url) cta.href = input.dataset.url;
      if (suivi) publier('brossange_finition', { source: 'hero', finition: input.value });
    };
    const coche = groupe.querySelector('input:checked');
    if (coche) appliquer(coche, false);
    groupe.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) appliquer(e.target, true);
    });
  });

  /* 4. Fiche : la couleur choisie repeint la brosse de la galerie et met à jour son texte alternatif */
  document.addEventListener('change', (e) => {
    if (e.target.name !== 'option-1') return;
    const section = e.target.closest('section');
    const brosse = section && section.querySelector('[data-gallery] [data-brosse]');
    if (!brosse) return;
    plaquer(brosse, poignee(e.target.value));
    brosse.setAttribute('aria-label', `Illustration de la brosse ovale, finition ${e.target.value}`);
    publier('brossange_finition', { source: 'fiche', finition: poignee(e.target.value) });
  });

  /* 5. Loupe au survol (souris) et gros plan au clavier ou au doigt */
  $$('[data-loupe]').forEach((cadre) => {
    const brosse = cadre.querySelector('[data-brosse]');
    if (!brosse) return;
    const K = 2.6;
    const loupe = document.createElement('div');
    loupe.className = 'loupe';
    loupe.setAttribute('aria-hidden', 'true');
    let copie = null;
    const preparer = () => {
      if (copie) return;
      copie = brosse.cloneNode(true);
      ['data-brosse', 'role', 'aria-label'].forEach((a) => copie.removeAttribute(a));
      copie.classList.add('loupe__brosse');
      loupe.appendChild(copie);
      cadre.appendChild(loupe);
    };
    cadre.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse' || cadre.classList.contains('is-gros-plan')) return;
      preparer();
      const rb = brosse.getBoundingClientRect();
      const rc = cadre.getBoundingClientRect();
      const x = e.clientX - rb.left;
      const y = e.clientY - rb.top;
      if (x < 0 || y < 0 || x > rb.width || y > rb.height * 0.58) { loupe.classList.remove('is-active'); return; }
      const R = loupe.offsetWidth / 2;
      loupe.style.transform = `translate(${e.clientX - rc.left - R}px, ${e.clientY - rc.top - R}px)`;
      copie.style.width = `${rb.width}px`;
      copie.style.transform = `translate(${R - x * K}px, ${R - y * K}px) scale(${K})`;
      copie.dataset.finition = brosse.dataset.finition;
      loupe.classList.add('is-active');
    });
    cadre.addEventListener('pointerleave', () => loupe.classList.remove('is-active'));
    const bouton = cadre.querySelector('[data-gros-plan]');
    if (bouton) {
      bouton.addEventListener('click', () => {
        const actif = cadre.classList.toggle('is-gros-plan');
        bouton.setAttribute('aria-pressed', String(actif));
        bouton.textContent = actif ? 'Vue entière' : 'Gros plan sur le coussin';
        loupe.classList.remove('is-active');
      });
    }
  });

  /* 6. Apparitions au défilement : seulement pour ce qui est sous la ligne de flottaison au chargement.
     Aucune mesure de position au chargement : le premier rappel de l'observateur dit ce qui est déjà à l'écran
     (laissé tel quel), les blocs encore plus bas passent en attente. Lancé quand le navigateur est libre. */
  if (!calme.matches && 'IntersectionObserver' in window) {
    const lancer = () => {
      const vus = new WeakSet();
      const groupes = new Map();
      const io = new IntersectionObserver((entrees) => entrees.forEach((en) => {
        const el = en.target;
        if (!vus.has(el)) {
          vus.add(el);
          if (en.isIntersecting || en.boundingClientRect.top <= window.innerHeight) { io.unobserve(el); return; }
          const parent = el.parentElement;
          const rang = groupes.get(parent) || 0;
          groupes.set(parent, rang + 1);
          el.classList.add('reveal', 'reveal-attente');
          el.style.transitionDelay = `${Math.min(rang, 5) * 70}ms`;
          return;
        }
        if (!en.isIntersecting) return;
        el.classList.remove('reveal-attente');
        io.unobserve(el);
      }), { rootMargin: '0px 0px -8% 0px' });
      $$('.section-head, .pack-card, .texture-card, .steps li, .table-frame, .faq-layout details, .final .arch, .value-card').forEach((el) => io.observe(el));
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(lancer, { timeout: 1500 }); else window.setTimeout(lancer, 200);
  }
})();
